import { Input, Button, Space } from 'antd';
import { SearchOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import _ from 'lodash';

export const QuoteTableConfig = (handleSearch, handleReset, editUserQuote, responsibilities) => {
  const getColumnSearchProps = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
    };
  };
  return [
    {
      title: 'Quote id',
      dataIndex: 'quote_id',
      key: 'quote_id',
      width: '3%',
    },
    {
      title: 'Client Name',
      dataIndex: 'category',
      key: 'vendor',
      width: '10%',
      ...getColumnSearchProps('category'),
    },
    {
      title: 'Request',
      dataIndex: 'quote_request',
      key: 'quote_request',
      width: '5%',
    },

    {
      title: 'Response',
      dataIndex: 'quote_response',
      key: 'quote_response',
      width: '5%',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '3%',
      render: (created_at) => {
        return <div>{created_at ? created_at.split('T')[0] : 'N/A'}</div>;
      },
    },
    {
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: '2%',
      render: (item) => {
        return (
          <div>
            <Space size="middle">
              <EyeOutlined style={{ color: '#0D8616', cursor: 'pointer', fontSize: '20px' }} />
              {_.includes(responsibilities, 'MANAGE_QUOTES_EDIT_BUTTON') ? (
                <EditOutlined
                  style={{ color: '#0D4B86', cursor: 'pointer', fontSize: '20px' }}
                  onClick={() => editUserQuote(item)}
                />
              ) : (
                ''
              )}
              {/* {_.includes(responsibilities, 'MANAGE_QUOTES_DELETE_BUTTON') ? (
                <DeleteOutlined
                  style={{ color: '#F52A0E', cursor: 'pointer', fontSize: '20px' }}
                  onClick={() => onDelete(item)}
                />
              ) : (
                ''
              )} */}
            </Space>
          </div>
        );
      },
    },
  ];
};
